import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    group: String
  }

  connect() {
    const tpl = this.element.querySelector("template[data-template]")
    if (tpl) {
      this.template = tpl.content.firstElementChild.cloneNode(true)
    }
    this.index = this.element.querySelectorAll("[data-promotion-module-id]").length

    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: ".handle",
      onEnd: () => {
        this.reorder()
      }
    })
  }

  // Détruit l'instance SortableJS au démontage (navigation Turbo) pour libérer
  // les listeners attachés à l'élément et éviter une fuite mémoire.
  disconnect() {
    this.sortable?.destroy()
    this.sortable = null
  }

  add(event) {
    event.preventDefault()
    if (!this.template) {
      console.warn("Template manquant : aucun élément [data-promotion-module-id] n'a pu être cloné.")
      return
    }

    const newItem = this.template.cloneNode(true)
    this.index += 1
    newItem.setAttribute("data-promotion-module-id", this.index)

    newItem.querySelectorAll("input, select, textarea, label").forEach(el => {
      if (el.name) el.name = el.name.replace(/\[\d+\]/g, `[${this.index}]`)
      if (el.id) el.id = el.id.replace(/_\d+_/g, `_${this.index}_`)
      if (el.htmlFor) el.htmlFor = el.htmlFor.replace(/_\d+_/g, `_${this.index}_`)
    })

    newItem.querySelectorAll("input, select, textarea").forEach(el => {
      if (el.type !== "hidden") el.value = ""
    })

    const addButton = this.element.querySelector("[data-action='click->promotion-module#add']")
    if (addButton?.parentNode === this.element) {
      this.element.insertBefore(newItem, addButton)
    } else {
      this.element.appendChild(newItem)
    }
  }

  remove(event) {
    event.preventDefault()
    const target = event.target.closest("[data-promotion-module-id]")
    if (target) {
      // Ajouter un champ caché _destroy avant de supprimer l'élément
      const destroyField = document.createElement("input")
      destroyField.type = "hidden"
      destroyField.name = target.querySelector("select").name.replace("[learning_module_id]", "[_destroy]")
      destroyField.value = "1"
      target.parentNode.insertBefore(destroyField, target)
      
      target.remove()
      this.reorder()
    }
  }

  reorder() {
    this.element.querySelectorAll("[data-promotion-module-id]").forEach((el, index) => {
      const input = el.querySelector("input[name*='[position]']")
      if (input) input.value = index + 1
    })
  }

  addSlot(event) {
    event.preventDefault()

    const moduleEl = event.target.closest("[data-promotion-module-id]")
    if (!moduleEl) return

    const slotsContainer = moduleEl.querySelector("[data-slots-container]")
    const template = moduleEl.querySelector("template[data-slot-template]")
    if (!slotsContainer || !template) return

    const index = Date.now()
    const newSlot = template.content.cloneNode(true)

    newSlot.querySelectorAll("input, select, textarea").forEach(el => {
      if (el.name) el.name = el.name.replace(/\[TEMPLATE\]/g, `[${index}]`)
      if (el.id) el.id = el.id.replace(/TEMPLATE/g, `${index}`)
    })

    slotsContainer.appendChild(newSlot)
  }

  removeSlot(event) {
    event.preventDefault()

    const slotEl = event.target.closest(".bg-gray-100")
    if (!slotEl) return

    const destroyField = slotEl.querySelector("input[name*='_destroy']")
    if (destroyField) {
      destroyField.value = "1"
    }

    slotEl.style.display = "none"
  }
}